import * as THREE from "../../../utils/basejs/three.module";

import {
    addConstShape, addFont,
    addSvg, clearScene,
} from "../../../utils/basejs/addThreeThings";

/*import {
    addFont,
    addShape,
    addStableArrow,
    addConstShape,
    addConstFont
} from "../../../utils/basejs/addThreeThings";
import {LineGeometry} from "../../../utils/basejs/LineGeometry";
import {Line2} from "../../../utils/basejs/Line2";*/
import {SVGLoader} from "../../../utils/basejs/SVGLoader";

const thingGroup = new THREE.Group();
const secGroup = new THREE.Group();
const pointGroup = new THREE.Group();
const textGroup = new THREE.Group();

function clearText(){
    clearScene(textGroup);
}
function clearSection() {
    clearScene(secGroup);
}
function addTextGroup(){
    thingGroup.add(textGroup);
}
function removeTextGroup(){
    thingGroup.remove(textGroup);
}
function addGroup(group){
    group.add(thingGroup);
    if(!secGroup.name) {
        secGroup.name = 'section';
    }
    group.add(secGroup);
    if(!pointGroup.name) {
        pointGroup.name = 'mps';
    }
    if(!textGroup.name){
        textGroup.name = 'text';
    }
    thingGroup.add(textGroup);
    group.add(pointGroup);
}
function addLine(data)  {
    if(!data){
        return;
    }
    if(secGroup.children.length > 0){
        clearScene(secGroup);
    }
    const shape = new THREE.Shape();
    shape.moveTo(0,0);
    shape.lineTo(-2,0).lineTo(-2,10).lineTo(0,10).lineTo(0,20).lineTo(-2,20)
        .lineTo(-2,30).lineTo(0,30).lineTo(0,40).lineTo(-2,40)
        .lineTo(-2,50).lineTo(0,50).lineTo(0,60).lineTo(-2,60)
        .lineTo(-2,70).lineTo(0,70).lineTo(0,80).lineTo(-2,80)
        .lineTo(-2,90).lineTo(0,90).lineTo(0,100).lineTo(-2,100)
        .lineTo(-2,110).lineTo(0,110).lineTo(0,120).lineTo(-2,120)
        .lineTo(-2,130).lineTo(0,130).lineTo(0,140).lineTo(-2,140)
        .lineTo(-2,150).lineTo(0,150).lineTo(0,160).lineTo(-2,160)
        .lineTo(-2,170).lineTo(0,170).lineTo(0,180).lineTo(-2,180)
        .lineTo(-2,190).lineTo(0,190).lineTo(0,200).lineTo(-2,200)
        .lineTo(-2,210).lineTo(0,210).lineTo(0,220).lineTo(-2,220)
        .lineTo(-2,230).lineTo(0,230).lineTo(0,240).lineTo(-2,240)
        .lineTo(-2,250).lineTo(0,250).lineTo(0,260).lineTo(-2,260)
        .lineTo(-2,270).lineTo(0,270).lineTo(0,280).lineTo(-2,280)
        .lineTo(-2,290).lineTo(0,290).lineTo(0,300).lineTo(-2,300)
        .lineTo(-2,310).lineTo(0,310).lineTo(0,320).lineTo(-2,320)
        .lineTo(-2,330).lineTo(0,330).lineTo(0,340).lineTo(-2,340)

        .lineTo(-2,350).lineTo(0,350).lineTo(0,360).lineTo(-2,360)
        .lineTo(-2,370).lineTo(0,370).lineTo(0,380).lineTo(-2,380)
        .lineTo(-2,390).lineTo(0,390).lineTo(0,400).lineTo(-2,400)
        .lineTo(-2,410).lineTo(0,410).lineTo(0,420).lineTo(-2,420)
        .lineTo(-2,430).lineTo(0,430).lineTo(0,440).lineTo(-2,440)
        .lineTo(-2,450).lineTo(0,450).lineTo(0,460).lineTo(-2,460)
        .lineTo(-2,470).lineTo(0,470).lineTo(0,480).lineTo(-2,480)

        .lineTo(-2,490).lineTo(2,490)

        .lineTo(2,480).lineTo(0,480).lineTo(0,470).lineTo(2,470)
        .lineTo(2,460).lineTo(0,460).lineTo(0,450).lineTo(2,450)
        .lineTo(2,440).lineTo(0,440).lineTo(0,430).lineTo(2,430)
        .lineTo(2,420).lineTo(0,420).lineTo(0,410).lineTo(2,410)
        .lineTo(2,400).lineTo(0,400).lineTo(0,390).lineTo(2,390)
        .lineTo(2,380).lineTo(0,380).lineTo(0,370).lineTo(2,370)
        .lineTo(2,360).lineTo(0,360).lineTo(0,350).lineTo(2,350)


        .lineTo(2,340).lineTo(0,340).lineTo(0,330).lineTo(2,330)
        .lineTo(2,320).lineTo(0,320).lineTo(0,310).lineTo(2,310)
        .lineTo(2,300).lineTo(0,300).lineTo(0,290).lineTo(2,290)
        .lineTo(2,280).lineTo(0,280).lineTo(0,270).lineTo(2,270)
        .lineTo(2,260).lineTo(0,260).lineTo(0,250).lineTo(2,250)
        .lineTo(2,240).lineTo(0,240).lineTo(0,230).lineTo(2,230)
        .lineTo(2,220).lineTo(0,220).lineTo(0,210).lineTo(2,210)
        .lineTo(2,200).lineTo(0,200).lineTo(0,190).lineTo(2,190)
        .lineTo(2,180).lineTo(0,180).lineTo(0,170).lineTo(2,170)
        .lineTo(2,160).lineTo(0,160).lineTo(0,150).lineTo(2,150)
        .lineTo(2,140).lineTo(0,140).lineTo(0,130).lineTo(2,130)
        .lineTo(2,120).lineTo(0,120).lineTo(0,110).lineTo(2,110)
        .lineTo(2,100).lineTo(0,100).lineTo(0,90).lineTo(2,90)
        .lineTo(2,80).lineTo(0,80).lineTo(0,70).lineTo(2,70)
        .lineTo(2,60).lineTo(0,60).lineTo(0,50).lineTo(2,50)
        .lineTo(2,40).lineTo(0,40).lineTo(0,30).lineTo(2,30)
        .lineTo(2,20).lineTo(0,20).lineTo(0,10).lineTo(2,10)
        .lineTo(2,0).lineTo(0,0);
    const lines = [];
    const textArray = [];
    // const material = new THREE.MeshBasicMaterial( { color: 0x03FFBB });
    const material = new THREE.MeshBasicMaterial( { color: '#EE2C2C'} );
    for(let d of data) {
        const x = parseFloat(d.x);
        const position = {x: x,y: 240,z: 0.1};
        lines.push({ shape: shape, position: position, material : material,name: d.damcd});
        textArray.push({text: d.damnm, material: material, position: {x: x - 20, y: 740, z: 0.3}, size: 10});
    }
    addFont(textArray,material,textGroup);
    addConstShape(lines,secGroup);
    material.dispose();
}
function addPoint(data,needStatus){
    if(!data){
        return;
    }
    const geometry = new THREE.CircleGeometry( 12, 32 );

    if(pointGroup.children.length > 0){
        clearScene(pointGroup);
    }
    const textArray = [];
    const textMat = new THREE.MeshBasicMaterial( { color: '#000' } );
    if(needStatus){
        const geometry = new THREE.CircleGeometry( 6, 32 );
        const material1 = new THREE.MeshBasicMaterial( { color: 'rgb(250,144,0)' } );
        const circleStatus = new THREE.Mesh(geometry, material1);
        const material2 = new THREE.MeshBasicMaterial( { color: 'rgb(255,255,255)' } );
        const plane1Geo = new THREE.PlaneGeometry( 1, 1);
        const plane2Geo = new THREE.PlaneGeometry( 1, 6);
        const plane1 = new THREE.Mesh(plane1Geo, material2);
        const plane2 = new THREE.Mesh(plane2Geo, material2);
        plane1.position.set(0,-4,0.1);
        plane2.position.set(0,1,0.1);
        circleStatus.add(plane1)
        circleStatus.add(plane2)
        for(let d of data) {
            const material = new THREE.MeshBasicMaterial( { color: '#3F00FF' } );
            const circle = new THREE.Mesh(geometry, material);
            const x = parseFloat(d.x);
            const y = parseFloat(d.y);
            circle.position.set(x, y, 0.2);
            textArray.push({text: d.mpcd, material: textMat, position: {x: x + 15, y: y, z: 0.3}, size: 10});
            circle.bh =  d.mpcd;
            const status = d.status;
            circle.status = status;
            if(status === 0) {
                const circ = circleStatus.clone();
                circ.position.set(-10,10,0.1);
                circle.add(circ);
                // circle.status = 1;
            }
            pointGroup.add(circle);
        }
    }else {
        for(let d of data) {
            const material = new THREE.MeshBasicMaterial( { color: '#3F00FF' } );
            const circle = new THREE.Mesh(geometry, material);
            const x = parseFloat(d.x);
            const y = parseFloat(d.y);
            circle.position.set(x, y, 0.2);
            textArray.push({text: d.mpcd, material: textMat, position: {x: x + 15, y: y, z: 0.3}, size: 10});
            // }
            circle.bh =  d.mpcd;
            pointGroup.add(circle);
            // i++;
        }
    }

    addFont(textArray,null,textGroup);
    geometry.dispose();
}
function addThings(){
    //svg
    const svgLoader = new SVGLoader();
    addSvg(svgLoader,thingGroup,{x:0,y:1100,z:0},'../images/dam/dam.svg',false,true);
    /*const texture1 = new THREE.TextureLoader().load('../images/dam/monitor.jpg');
    const material2 = new THREE.MeshBasicMaterial({map: texture1 , transparent: true,flatShading:true});
    const planeGeo = new THREE.PlaneGeometry(176,100);
    const sk = new THREE.Mesh(planeGeo,material2);
    sk.position.set(50,50,0)
    thingGroup.add(sk);*/

    //添加大坝
    /*const damShape = new THREE.Shape();
    const dtMat = new THREE.MeshBasicMaterial({color: '#51575C'});
    const texture = new THREE.TextureLoader().load('../images/dam/monitor.png');
    const material1 = new THREE.MeshBasicMaterial({map: texture , transparent: true,flatShading:true});
    const lineMat = new THREE.MeshBasicMaterial({color:'#a09a88'})
    const extrudeSettings = {
        depth: 50 ,
        bevelEnabled: false,
        steps:1
    };
    const stoneSettings = {
        depth: 3 ,
        bevelEnabled: false,
        steps:1
    };
    const extrudeSetting = {
        steps: 2,
        depth: 1,
        bevelEnabled: true,
        bevelThickness: 1,
        bevelSize: 1,
        bevelOffset: 0,
        bevelSegments: 1
    };
    const pzSettings = {
        depth: 20 ,
        bevelEnabled: false,
        steps:1
    };
    damShape.moveTo(0,0);
    damShape.lineTo(100,0).lineTo(68,40)
        .bezierCurveTo(68,40,65,42,65,45).lineTo(65,50)
        .lineTo(45,50).lineTo(45,45).bezierCurveTo(45,45,45,42,42,40).lineTo(0,0);
    const damGeo = new THREE.ExtrudeGeometry(damShape, extrudeSettings);
    const damMesh = new THREE.Mesh(damGeo, [dtMat,material1]);
    const geometryPoints = new THREE.BufferGeometry().setFromPoints(damShape.getPoints());
    const line = new THREE.Line(geometryPoints, lineMat);
    let i = 0;
    for(;i < 3;i++){
        const damClone = damMesh.clone();
        let z = i * 50 + 50;
        if(i > 0){
            z = i * 50 + 100;
        }
        damClone.position.set(0,0,z);
        const lineClone = line.clone();
        const lineClone1 = lineClone.clone();
        lineClone1.position.set(0,0,50);
        damClone.add(lineClone);
        damClone.add(lineClone1);
        thingGroup.add(damClone);
    }
    // font1Mesh.rotateX(Math.PI*3/2)
    damMesh.add(line);
    const lineClone = line.clone();
    lineClone.position.set(0,0,50);
    damMesh.add(lineClone);
    //大坝上的
    const pzShape = new THREE.Shape();
    pzShape.moveTo(0,0);
    pzShape.lineTo(0,15).lineTo(10,15).lineTo(10,10)
        .bezierCurveTo(10,10,10,8,7,6).lineTo(0,0);
    const pzPoints = new THREE.BufferGeometry().setFromPoints(pzShape.getPoints());
    const pzLine = new THREE.Line(pzPoints, lineMat);
    const pzLine1 = pzLine.clone();
    const pzGeo = new THREE.ExtrudeGeometry(pzShape, pzSettings);
    const pzMesh = new THREE.Mesh(pzGeo, [dtMat,material1]);
    pzMesh.add(pzLine);
    pzLine1.position.set(0,0,20);
    pzMesh.add(pzLine1);
    pzMesh.position.set(35,35,10)


    const pzMesh1 = pzMesh.clone();
    pzMesh1.position.set(35,35,160);

    const pzMesh2 = pzMesh.clone();
    const pzMesh3 = pzMesh.clone();
    pzMesh2.position.set(75,35,180);
    pzMesh3.position.set(75,35,30);

    pzMesh2.rotateY(Math.PI);
    pzMesh3.rotateY(Math.PI);

    //泄洪道
    const spillway = new THREE.Shape();
    spillway.moveTo(0,0);
    spillway.lineTo(100,0).lineTo(68,40)
        .bezierCurveTo(68,40,45,45,42,40).lineTo(0,0);
    const spillGeo = new THREE.ExtrudeGeometry(spillway, extrudeSettings);
    const spillMesh = new THREE.Mesh(spillGeo, [dtMat,material1]);
    const spillPoints = new THREE.BufferGeometry().setFromPoints(damShape.getPoints());
    const spillLine = new THREE.Line(geometryPoints, lineMat);
    const spillLine1 = spillLine.clone();
    spillLine1.position.set(0,0,50);
    spillMesh.add(spillLine);
    spillMesh.add(spillLine1);
    spillMesh.position.set(0,0,100);

    //泄洪道上的路面
    const roadShape = new THREE.BoxGeometry(20,1,50);
    const roadMesh = new THREE.Mesh(roadShape,material1);
    roadMesh.position.set(55,49.5,125);

    //泄洪道上的支柱
    const pillarShape = new THREE.BoxGeometry(30,8,3);
    const pillarMesh = new THREE.Mesh(pillarShape,material1);
    pillarMesh.position.set(54,40,125);

    const cylinderGeo = new THREE.CylinderGeometry( 1, 1, 8, 32 );
    const cylinder = new THREE.Mesh( cylinderGeo, material1 );
    cylinder.position.set(-15,0,0);
    const cylinder1 = cylinder.clone();
    cylinder1.position.set(15,0,0);
    pillarMesh.add(cylinder1);
    pillarMesh.add(cylinder);

    const cyGeo = new THREE.CylinderGeometry( 1.5, 1.5, 2, 8 );
    const cylinder2 = new THREE.Mesh( cyGeo, material1 );
    cylinder2.position.set(-14,5,0);
    const cylinder3 = cylinder2.clone();
    cylinder3.position.set(14,5,0);
    pillarMesh.add(cylinder2);
    pillarMesh.add(cylinder3);

    const pillarUpShape = new THREE.Shape();
    pillarUpShape.moveTo(0,0).lineTo(27,0).lineTo(27,4).lineTo(0,4).lineTo(0,0);
    const pillarUpGeo = new THREE.ExtrudeGeometry( pillarUpShape, extrudeSetting );
    const pillarUpMesh = new THREE.Mesh(pillarUpGeo,material1);
    pillarUpMesh.position.set(-13.5,4,-0.5);
    pillarMesh.add(pillarUpMesh);

    //石柱子
    const stone = new THREE.Shape();
    stone.moveTo(0,0).lineTo(0.5,0).lineTo(0.5,2).lineTo(1,2).lineTo(1,2.5).lineTo(0,2.5).lineTo(0,0);
    const stoneGeo = new THREE.ExtrudeGeometry(stone, stoneSettings);
    const stoneMesh = new THREE.Mesh(stoneGeo,material1);
    stoneMesh.position.set(-9.5,8,-1.5);
    const stoneMesh1 = stoneMesh.clone();
    stoneMesh1.rotateY(Math.PI);
    stoneMesh1.position.set(11.5,8,1.5);
    pillarMesh.add(stoneMesh);
    pillarMesh.add(stoneMesh1);

    //圆柱
    const cGeo = new THREE.CylinderGeometry( 0.5, 0.5, 0.5, 32 );
    const cy = new THREE.Mesh( cGeo, material1 );
    cy.position.set(-9,10.5,0);
    const cy1 = cy.clone();
    cy1.position.set(11,10.5,0);
    pillarMesh.add(cy1);
    pillarMesh.add(cy);

    const pillarMesh1 = pillarMesh.clone();

    pillarMesh1.position.set(54,40,100);

    const pillarMesh2 = pillarMesh.clone();
    pillarMesh2.position.set(54,40,150);

    //挡水板
    const waterBaffleShape = new THREE.Shape();
    waterBaffleShape.moveTo(0,0).lineTo(40,0).lineTo(40,1).lineTo(0,1).lineTo(0,0);


    thingGroup.add(pillarMesh);
    thingGroup.add(pillarMesh1);
    thingGroup.add(pillarMesh2);
    thingGroup.add(roadMesh);
    thingGroup.add(spillMesh);
    thingGroup.add(damMesh);
    thingGroup.add(pzMesh);
    thingGroup.add(pzMesh1);
    thingGroup.add(pzMesh2);
    thingGroup.add(pzMesh3);*/

}

// export {timeConstShapeGroup,timeShapeGroup,timeLineGroup,timeFontGroup,timeStableArrowGroup,timeDataShowGroup,timeDyShow,timeDyTextShow,addThings,addSystemLine,addDyysGroup};
export {addGroup,addThings,addPoint,addLine,clearText,addTextGroup,removeTextGroup,clearSection};
